import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch, Redirect } from "react-router-dom";

import { Footer } from "components";

import pagesRoutes from "routes/pages.jsx";
import Login from "views/Pages/LoginPage.jsx";
import ResetPass from "views/Pages/ResetPass.jsx";
import RequestPass from "views/Pages/RequestPass.jsx";

var ps;

class Pages extends React.Component {
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.fullPages);
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }
  render() {
    return (
      <div>
        {/* <PagesHeader {...this.props} /> */}
        <div className="wrapper wrapper-full-page" ref="fullPages">
          <div className="full-page section-image">
            <Switch>
              <Route path="/entrar" render={
                  props => <Login {...props} godMode={this.props.godMode} showNotification={this.props.showNotification} mainState={this.props.mainState} userData={this.props.userData}/>
              } />
              <Route path="/restablecer" render={
                  props => <ResetPass {...props} godMode={this.props.godMode} showNotification={this.props.showNotification} mainState={this.props.mainState} goToLogin={this.props.goToLogin}/>
              } />        
              <Route path="/recuperar" render={
                  props => <RequestPass {...props} godMode={this.props.godMode} showNotification={this.props.showNotification} mainState={this.props.mainState} goToLogin={this.props.goToLogin}/>
              } />
              {pagesRoutes.map((prop, key) => {
                if (prop.redirect)
                  return (
                    <Redirect from={prop.path} to={prop.pathTo} key={key} />
                  );
                return (
                  <Route
                    path={prop.path}
                    component={prop.component}
                    key={key}
                  />
                );
              })}
            </Switch>
            <Footer fluid />
          </div>
        </div>
      </div>
    );
  }
}

export default Pages;



// WEBPACK FOOTER //
// ./src/layouts/Pages/Pages.jsx